import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ShareSortBys } from '../../fragments/generated/ShareSortBys';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareSortBysMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  sortBys?: Types.InputMaybe<Array<Types.MetadataSortByInput>>;
}>;


export type UpdateShareSortBysMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, customSort: boolean, sortBys?: { __typename?: 'MetadataSortByConnection', totalCount: number, nodes: Array<{ __typename?: 'MetadataSortBy', id?: string | null, direction: Types.OrderDirectionEnum, fieldDefinition: { __typename?: 'ProjectFieldDefinition', fieldType: Types.FieldTypeEnum, id: string, isDefaultField?: boolean | null, isFilterable?: boolean | null, isGroupable?: boolean | null, isSortable?: boolean | null, isSystemField: boolean, name: string, configuration?: { __typename?: 'DateFieldConfiguration', displayFormat?: Types.DisplayFormatEnum | null, displayTimezone?: boolean | null, includeTime?: boolean | null, timeFormat?: Types.TimeFormatEnum | null } | { __typename?: 'NumberFieldConfiguration', scale?: number | null } | { __typename?: 'RatingFieldConfiguration', color?: string | null, maxValue: number, style?: Types.RatingStyleEnum | null } | { __typename?: 'SelectFieldConfiguration', options: Array<{ __typename?: 'SelectOption', color?: string | null, displayName: string, id: string }> } | { __typename?: 'ToggleFieldConfiguration', color?: string | null } | { __typename?: 'UserFieldConfiguration', memberOptionsType: Types.MemberOptionsTypeEnum, notifyMembers: boolean, customMembers?: Array<{ __typename?: 'CustomMember', id: string, type: Types.CustomMemberTypeEnum }> | null } | { __typename?: 'UsersFieldConfiguration', memberOptionsType: Types.MemberOptionsTypeEnum, notifyMembers: boolean, selectType: Types.MemberSelectTypeEnum, customMembers?: Array<{ __typename?: 'CustomMember', id: string, type: Types.CustomMemberTypeEnum }> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } | { __typename?: 'CollectionShare', id: string, customSort: boolean } | null } | null };


export const UpdateShareSortBys = /*#__PURE__*/ gql`
    mutation UpdateShareSortBys($shareId: ID!, $sortBys: [MetadataSortByInput!]) {
  updateShare(
    input: {shareId: $shareId, sortBys: $sortBys, settings: {customSort: false}}
  ) {
    share {
      id
      customSort
      ...ShareSortBys
    }
  }
}
    ${ShareSortBys}` as unknown as DocumentNode<UpdateShareSortBysMutation, UpdateShareSortBysMutationVariables>;

          

          export const useUpdateShareSortBysMutation = (options?:MutationHookOptions<UpdateShareSortBysMutation, UpdateShareSortBysMutationVariables>) => useMutation(UpdateShareSortBys, options);
          

          export type UpdateShareSortBysMutationOptions = MutationHookOptions<UpdateShareSortBysMutation, UpdateShareSortBysMutationVariables>;

          

          export type UpdateShareSortBysMutationResult = ReturnType<typeof useUpdateShareSortBysMutation>[1];

          
